export const SCI_MANAGERS = ['Gary', 'Catherine'] as const;
